import { Flex, Grid, HStack, Text } from '@chakra-ui/react';
import { RecipeHomepageResponse } from '@diamond/shared/types';
import { Button } from '@diamond/shared/ui';
import { trackEvent } from '@diamond/shared/utils';
import { TRACKING_EVENTS, TRACKING_PAGES } from '@diamond/sol-buyer/constant';
import Link from 'next/link';

import { BleedBackground } from '../layouts';
import { RecipeCard } from '../recipes/RecipeCard';
import { RecipeCardMobile } from '../recipes/RecipeCardMobile';

type RecipeHomepageProps = {
  data: RecipeHomepageResponse;
};

export function RecipeHomepage({ data }: RecipeHomepageProps) {
  return (
    <Flex
      flexDirection="column"
      position="relative"
      px={{ base: '0', md: '4' }}
      py={{ base: '7', md: '8' }}
      gap="4"
    >
      <BleedBackground
        bgImage="url('/images/recipe-pattern.png')"
        bgRepeat="repeat"
        bgSize="12px"
        bgColor="#FEF9F2"
        backgroundBlendMode="luminosity"
      />
      <HStack
        spacing="5"
        justifyContent={{ base: 'space-between', md: 'unset' }}
        alignItems="flex-end"
      >
        <Text
          as="span"
          fontSize={{ base: '22px', md: '2xl' }}
          fontWeight={{ base: 'regular', md: 'bold' }}
          lineHeight="1"
        >
          {data.title}
        </Text>
        <Button
          as={Link}
          onClick={() =>
            trackEvent(`click_recipe_others`, {
              datetime: new Date().toISOString(),
              count_recipe: data.count,
              section_name: 'homepage',
            })
          }
          href="/recipes"
        >
          <Text
            fontSize={{ base: 'xs', md: 'sm' }}
            fontWeight="semibold"
            color="blue"
            lineHeight="1"
            data-testid="recipe-others-button"
          >
            {`Resep Lainnya (${data.count})`}
          </Text>
        </Button>
      </HStack>
      <Grid
        display={{ base: 'grid', lg: 'none' }}
        templateColumns="repeat(3, minmax(0, 1fr))"
        columnGap="3"
        rowGap="6"
      >
        {data.recipes.map((recipe) => (
          <RecipeCardMobile
            key={recipe.title}
            recipe={recipe}
            handleTrackEvent={() =>
              trackEvent(TRACKING_EVENTS.SELECT_RECIPE, {
                id: recipe.id,
                name: recipe.title,
                brand: recipe.brands.toString(),
                section_name: 'Recipes',
                page_name: TRACKING_PAGES.BERANDA,
              })
            }
            section={TRACKING_PAGES.BERANDA}
          />
        ))}
      </Grid>
      <Grid
        display={{ base: 'none', lg: 'grid' }}
        templateColumns="repeat(3, minmax(0, 1fr))"
        columnGap="8"
        rowGap="8"
      >
        {data.recipes.map((recipe) => (
          <RecipeCard
            key={recipe.title}
            recipe={recipe}
            isCompact
            handleTrackEvent={() =>
              trackEvent(TRACKING_EVENTS.SELECT_RECIPE, {
                id: recipe.id,
                name: recipe.title,
                brand: recipe.brands.toString(),
                section_name: 'Recipes',
                page_name: TRACKING_PAGES.BERANDA,
              })
            }
            section={TRACKING_PAGES.BERANDA}
          />
        ))}
      </Grid>
    </Flex>
  );
}
